import * as React from 'react';
import * as classnames from 'classnames/bind';
import bind from 'bind-decorator';
import {RouteComponentProps} from 'react-router';
import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';
import {Dialog} from '@mintdata-wsp/wsp/ui/components/forms/Dialog';
import {Column} from '@mintdata-wsp/wsp/ui/components/forms/Column';
import {Row} from '@mintdata-wsp/wsp/ui/components/forms/Row';
import {TextRun} from '@mintdata-wsp/wsp/ui/components/text/TextRun';
import {links} from '@mintdata-wsp/wsp/ui/routes/Routing';
import {MDIcons} from '@mintdata-wsp/common/components/icon/MDIcons';
import {Form, IFormData} from "@mintdata-wsp/common/components/form/Form";
import {Input} from "@mintdata-wsp/common/components/input/Input";
import {ErrorPopupSide} from "@mintdata-wsp/common/components/formField/FormField";
import {Button} from '@mintdata-wsp/common/components/button/Button';
import {DialogError} from "@mintdata-wsp/wsp/ui/components/forms/DialogError";
import {WindowLocationUtil} from "@mintdata-wsp/common/util/WindowLocationUtil";
import {observer} from "mobx-react";
import {rootState} from "@mintdata-wsp/common/state/RootState";
import {Spinner, SpinnerSize, SpinnerStyle} from "@mintdata-wsp/common/components/spinner/Spinner";

const styles = require('./SignupForm.less');
const cx = classnames.bind(styles);

@observer
export class SignupForm extends React.Component<RouteComponentProps<any>, any>
{
    private _form:Form = new Form({
        onSubmit: this._onFormSubmit,
    });

    @bind
    private _onFormSubmit(formData:IFormData)
    {
        controllers.ui.signUp.submitForm(this._form);
    }

    @bind
    private _onClickSignUpButton(e:React.SyntheticEvent<any>):void
    {
        this._form.submit();
    }

    private _getSpinner():JSX.Element
    {
        return <Spinner size={SpinnerSize.Medium_24} style={SpinnerStyle.White} />;
    }

    render()
    {
        const controller = controllers.ui.signUp;
        const organizationsController = controllers.data.organizations;
        const {isSignUpInProgress} = rootState.ui.signUpPage;

        const rootDomain = WindowLocationUtil.getRootDomain();
        const commonErrorMessage = this._form.getServerError('_');

        return  (
            <Dialog className={cx('signupDialog')} title={'Sign Up'}>

                <DialogError message={commonErrorMessage}/>

                <div className={cx('signupForm')}>

                    <Column>
                        <Input icon={MDIcons.common.Person}
                               className={cx('input')}
                               placeholder={'John Appleseed'}
                               form={this._form}
                               formKey={'fullname'}
                               isInitiallyFocused={true}
                               validationFn={controller.validateFullName}
                               errorPopupSide={ErrorPopupSide.Right}
                        />

                        <Input icon={MDIcons.common.Email}
                               className={cx('input')}
                               placeholder={'john@appleseed.com'}
                               form={this._form}
                               formKey={'email'}
                               validationFn={controller.validateEmail}
                               errorPopupSide={ErrorPopupSide.Right}
                        />

                        <Input icon={MDIcons.common.PasswordKey}
                               className={cx('input')}
                               placeholder={'Password'}
                               isPassword={true}
                               form={this._form}
                               formKey={'password'}
                               validationFn={controller.validatePassword}
                               errorPopupSide={ErrorPopupSide.Right}
                        />

                    </Column>

                    <Column>
                        <Input icon={MDIcons.common.People}
                               className={cx('input')}
                               placeholder={'Acme, Inc.'}
                               form={this._form}
                               formKey={'organizationName'}
                               validationFn={organizationsController.validateOrganizationName}
                               errorPopupSide={ErrorPopupSide.Right}
                        />

                        <Row className={cx('siteRow')}>
                            <Input className={cx('siteId')}
                                   icon={MDIcons.common.World}
                                   placeholder={'acme-inc'}
                                   form={this._form}
                                   formKey={'organizationSiteId'}
                                   validationFn={organizationsController.validateOrganizationSiteId}
                                   errorPopupSide={ErrorPopupSide.Right}
                            />
                            <div className={cx('siteFixedHostPart')}>
                                .{rootDomain}
                            </div>
                        </Row>

                    </Column>

                    <Row className={cx('mainButtonRow')}>
                        <Button caption={'SIGN UP'}
                                className={cx('mainButton')}
                                onClick={this._onClickSignUpButton}
                                icon={isSignUpInProgress ? this._getSpinner() : null}
                                relativeIcon={true}
                                isDisabled={isSignUpInProgress}
                        />
                    </Row>

                    <TextRun>
                        Already have an account?
                        {links.toLogin('Login', cx('actionLink'))}
                    </TextRun>

                </div>
            </Dialog>
        );
    }
}
